module.exports = __webpack_public_path__ + "img/wechat-jilu.7305be2d.png";